import { Stack, Text, Box, VStack } from '@chakra-ui/react'
import { useSpring } from 'react-spring'
import { useInView } from 'react-intersection-observer'
import { useTranslation } from 'next-i18next'

import { AnimatedStack, DEFAULT_SPRING_CONFIG } from '@/lib/springComponent'

interface Props {
  children: React.ReactNode
}

function Princing({ children }: Props): React.ReactElement {
  const { t } = useTranslation('services')

  const { ref, inView } = useInView({
    threshold: 0.3,
    triggerOnce: true,
  })

  const spring = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translate3d(0, 0px, 0)' : 'translate3d(0, 16px, 0)',
    config: DEFAULT_SPRING_CONFIG,
  })

  return (
    <AnimatedStack
      style={spring}
      ref={ref}
      sx={{
        borderRadius: '2xl',
        bg: 'primary.400',
        px: { base: 2, sm: 3 },
        border: '1px solid',
        borderColor: 'inherit',
      }}
    >
      <Stack
        sx={{
          borderRadius: '2xl',
          bg: 'white',
          py: { base: 6, sm: 8 },
          px: { base: 6, sm: 8, md: 12 },
        }}
      >
        <VStack spacing="1" layerStyle="landingSectionHeading" sx={{ pb: 0 }}>
          <Text textStyle="landingSectionTitle">{t('common.pricing')}</Text>
        </VStack>
        <Box sx={{ textAlign: 'center', fontSize: { base: 'lg', sm: '2xl' } }}>
          {typeof children === 'string' ? <Text>{children}</Text> : children}
        </Box>
      </Stack>
    </AnimatedStack>
  )
}

export default Princing
